import { selectProductsTags, selectServerFilters } from '../selectors/filters';

import { useAppSelector } from './redux';

export const useServerFilters = () => useAppSelector(selectServerFilters);
export const useProductsTags = () => useAppSelector(selectProductsTags);
